<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :addColumns="addColumns"
      :editColumns="addColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';

  export default {
    components: {
      pageTemplate
    },
    data() {
      return {
        // 高级搜索条件
        searchOptions: {
          simple: [
            {label: "标题", prop: "name", type: "input", ifFuzzy: true, placeholder: "请输入标题"}]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert'
          },
          {
            label: '修改',
            code: 'update'
          },
          {
            label: '删除',
            code: 'delete'
          }
        ],
        // 表格信息配置
        tableOptions: {
          columns: [
            {label: '序号', prop: 'id', width: '50', align: 'center'},
            {
              label: '标题',
              prop: 'title',
              width: '120',
              align: 'center'
            },
            {label: '内容', prop: 'content', width: '240', align: 'center'}
          ],
          url: api.system.notice
        },
        // 添加字段
        addColumns: {
          labelWidth: '130px',
          columns: [
            {
              label: '标题',
              type: 'input',
              prop: 'title',
              rule: [
                {required: true, message: '请输入标题', trigger: 'blur'},
                {
                  min: 2,
                  max: 15,
                  message: '长度在 2 到 15 个字符',
                  trigger: 'blur'
                }
              ]
            },
            {
              label: '内容',
              type: 'input',
              prop: 'content',
              rule: [
                {required: true, message: '请输入内容', trigger: 'blur'},
                {
                  min: 10,
                  max: 200,
                  message: '长度在 10 到 200 个字符',
                  trigger: 'blur'
                }
              ]
            }
          ],
          url: api.system.notice
        },
      };
    },
    created() {
    },
    methods: {}
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/system/Notice.vue